<div class="atn-app-page-content">
  @switch (pageIdSg()) {
    @case (PrebuiltPageId.DmsCatalog) {
      <atn-dms-catalog-page />
    }
    @case (PrebuiltPageId.DmsGraph) {
      <atn-dms-graph-page />
    }
    @case (PrebuiltPageId.DmsDimension) {
      <atn-dms-dimension-page />
    }
    @case (PrebuiltPageId.DmsEnum) {
      <atn-dms-enum-page />
    }
    @case (PrebuiltPageId.DmsEntity) {
      <atn-dms-model-page />
    }
    @case (PrebuiltPageId.MosaicDevActions) {
      <atn-mosaic-dev-actions-page />
    }
    @case (PrebuiltPageId.MosaicDevPages) {
      <atn-mosaic-dev-pages-page />
    }
    @case (PrebuiltPageId.MosaicDevWidgets) {
      <atn-mosaic-dev-widgets-page />
    }
    @case (PrebuiltPageId.MosaicDevPageBuilder) {
      <atn-mosaic-dev-page-builder-page />
    }
    @case (PrebuiltPageId.MosaicDevWidgetBuilder) {
      <atn-mosaic-dev-widget-builder />
    }
    @case (PrebuiltPageId.QuiverDeploymentCenter) {
      <atn-quiver-deployment-center-page />
    }
    @case (PrebuiltPageId.RateAllocations) {
      <p>TODO: content for RateAllocations</p>
    }
    @case (PrebuiltPageId.RateGl) {
      <atn-rate-gl-page />
    }
    @case (PrebuiltPageId.RateReports) {
      <atn-rate-reports-page />
    }
    @case (PrebuiltPageId.RateReport) {
      <atn-rate-report-page />
    }
    @case (PrebuiltPageId.RateRules) {
      <atn-rate-rules-page />
    }
    @case (PrebuiltPageId.SpaceRecordDetails) {
      <atn-space-record-details />
    }
    @case (PrebuiltPageId.SpaceRecordsList) {
      <atn-space-records-list />
    }
    @case (PrebuiltPageId.SpaceLiteRecordDetails) {
      <atn-space-lite-record-details />
    }
    @case (PrebuiltPageId.SpaceLiteRecordsList) {
      <atn-space-lite-records-list />
    }
    @case (PrebuiltPageId.SpaceServiceCenters) {
      <atn-space-service-centers />
    }
    @case (PrebuiltPageId.SpaceSurveyConfiguration) {
      <atn-space-survey-configuration />
    }
    @case (PrebuiltPageId.SpaceLiteSurveyConfiguration) {
      <atn-space-lite-survey-configuration />
    }
    @case (PrebuiltPageId.SpaceUserAccess) {
      <atn-space-user-access />
    }
    @case (PrebuiltPageId.SpaceLiteUserAccess) {
      <atn-space-lite-user-access />
    }
    @case (PrebuiltPageId.SpaceOrganizations) {
      <atn-space-organizations />
    }
    @case (PrebuiltPageId.SpaceClusters) {
      <atn-space-clusters />
    }
    @case (PrebuiltPageId.SpaceCluster) {
      <atn-space-cluster-details />
    }
    @case (PrebuiltPageId.SpaceReports) {
      <atn-space-reports />
    }
    @case (PrebuiltPageId.SpaceReport) {
      <atn-space-report />
    }
    @case (PrebuiltPageId.SummitAllocation) {
      <atn-summit-allocation-page />
    }
    @case (PrebuiltPageId.SummitCheckIns) {
      <atn-summit-check-ins-page />
    }
    @case (PrebuiltPageId.SummitOrganization) {
      <atn-summit-organization-page />
    }
    @case (PrebuiltPageId.SummitArchive) {
      <atn-summit-archive-page />
    }
    @case (PrebuiltPageId.SummitPulse) {
      <atn-summit-pulse-page />
    }
    @case (PrebuiltPageId.StmChat) {
      <atn-stm-chat-page />
    }
    @case (PrebuiltPageId.DolomiteChat) {
      <atn-dolomite-chat-page />
    }
    @case (PrebuiltPageId.DolomiteGeneralChat) {
      <atn-dolomite-general-chat-page />
    }
    @default {
      <atn-mosaic-page />
    }
    <!-- TODO: finish-->
  }
</div>
